<template>
  <div style="position:relative;">
    <div class="rasgado rasgado-top"></div>

    <section class="itinerario-poster" ref="sectionRef">

      <h2 class="poster-title">Itinerario</h2>

      <div
        v-for="(evento, index) in eventos"
        :key="evento.nombre"
        class="poster-item"
        :ref="el => itemRefs[index] = el"
      >
        <img :src="evento.icono" class="poster-icon" />
        <p class="poster-text">
          <span class="evento-nombre">{{ evento.nombre }}</span>
          <span class="evento-hora">{{ evento.hora }}</span>
          <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioPoster',
  setup() {
    const eventos = [
        {
      
      
        nombre: 'Ceremonia Religiosa',
        hora: '5:00 PM',
        icono: require('@/assets/iglesia-itinerario1.gif')
      },
      {
      
      
        nombre: 'Recepción',
        hora: '7:00 PM',
        icono: require('@/assets/copa1.png')
      },
      {
        nombre: ' Cena',
        hora: '8:00 PM',
        icono: require('@/assets/cena.png')
      },
   
      
      {
        nombre: 'Fiesta ',
        hora: '9:00 PM - en adelante',
        nota: 'A disfrutar la fiesta!',
        icono: require('@/assets/disc.png')
      }
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)

    onMounted(() => {
      itemRefs.value.forEach((el, index) => {
        if (!el) return

        const icon = el.querySelector('.poster-icon')
        const text = el.querySelector('.poster-text')

        gsap.set([icon, text], { opacity: 0 })

        const animations = [
          { y: 40 },
          { x: -40 },
          { scale: 0.85 },
          { x: 40 },
          { y: -40 },
          { scale: 0.9 },
          { x: -30 },
          { y: 30 }
        ]

        const fromVars = animations[index % animations.length]

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            gsap.fromTo(
              icon,
              { ...fromVars, opacity: 0 },
              { opacity: 1, x: 0, y: 0, scale: 1, duration: 1, ease: 'power3.out' }
            )

            gsap.fromTo(
              text,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: 'power2.out' }
            )

            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        observer.observe(el)
      })
    })

    return { eventos, itemRefs, sectionRef }
  }
}
</script>


<style scoped>
.itinerario-poster {
  overflow: hidden;
  padding: 60px 20px 80px;
  text-align: center;
  position: relative;
  perspective: 1000px;

  /* FONDO BASE */
  background:
    linear-gradient(
    to bottom,
    #9db096b1 0%,
    #97c0bc8f 40%,
    #bfd7bec6 100%
  ),
    url('@/assets/fn.avif') center center / cover no-repeat;
}

/* ==================== SOMBRAS Y REFLEJOS DE AGUA CÁUSTICA ==================== */

.itinerario-poster::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  
  background: 
    radial-gradient(ellipse at 30% 30%, rgba(115, 137, 106, 0.35) 0%, transparent 60%),
    radial-gradient(ellipse at 70% 70%, rgba(85, 105, 78, 0.25) 0%, transparent 65%),
    repeating-linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.03) 0px,
      rgba(0, 0, 0, 0.03) 20px,
      rgba(255, 255, 255, 0.15) 40px,
      rgba(255, 255, 255, 0.15) 60px
    );
  
  filter: blur(12px);
  pointer-events: none;
  z-index: 1;
  mix-blend-mode: multiply;
  animation: distorsionAgua 12s ease-in-out infinite alternate;
}

.itinerario-poster::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
  background: repeating-linear-gradient(
    -35deg,
    transparent 0%,
    rgba(255, 255, 255, 0.25) 15%,
    transparent 30%
  );
  
  filter: blur(8px);
  pointer-events: none;
  z-index: 1;
  mix-blend-mode: overlay;
  animation: brilloSuperficie 8s ease-in-out infinite alternate;
}

@keyframes distorsionAgua {
  0% {
    transform: translate(0, 0) rotate(0deg) scale(1);
  }
  50% {
    transform: translate(-3%, 2%) rotate(2deg) scale(1.05);
  }
  100% {
    transform: translate(2%, -3%) rotate(-1deg) scale(0.98);
  }
}

@keyframes brilloSuperficie {
  0% {
    opacity: 0.3;
    transform: translateY(-2%);
  }
  100% {
    opacity: 0.7;
    transform: translateY(2%);
  }
}

/* ===== SOMBRA EDITORIAL PROFUNDA PARA EL TÍTULO ===== */
.poster-title {
  font-family: 'Playfair Display', serif;
  font-size: 44px;
  letter-spacing: 2px;
  color: #2c2929;
  margin-bottom: 50px;
  position: relative;
  z-index: 2;
  text-shadow: 
    0 2px 4px rgba(255, 255, 255, 0.8),
    0 4px 15px rgba(0, 0, 0, 0.18);
  will-change: transform, opacity, filter, letter-spacing;
}

.poster-item {
  margin-bottom: 42px;
  position: relative;
  z-index: 2;
  will-change: transform;
}

/* ===== SOMBRA DE GOTA Y REALCE EN ICONOS ===== */
.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
  filter: 
    drop-shadow(0 8px 16px rgba(0, 0, 0, 0.22))
    drop-shadow(0 2px 4px rgba(255, 255, 255, 0.6));
  will-change: transform, opacity, filter;
  transform-style: preserve-3d;
}

/* ===== SOMBRAS MULTINIVEL DE ALTA LEGIBILIDAD PARA EL TEXTO ===== */
.poster-text {
  font-family: 'Playfair Display', serif;
  color: #1c1b1b;
  line-height: 1.4;
  text-shadow: 
    0 1px 2px rgba(255, 255, 255, 0.9),
    0 3px 12px rgba(0, 0, 0, 0.2);
  will-change: transform, opacity, filter;
}

.evento-nombre {
  display: block;
  font-size: 23px;
  font-weight: 600;
  letter-spacing: 0.03em;
}

.evento-hora {
  display: block;
  font-size: 20px;
  font-style: italic;
  margin-top: 4px;
  color: #383535;
  font-weight: 500;
}

.evento-nota {
  display: block;
  font-size: 15px;
  font-style: italic;
  margin-top: 6px;
  color: #555151;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  overflow: visible;
  background:
    radial-gradient(ellipse at 50% 20%, rgba(255, 255, 255, 0.95), rgba(253, 242, 243, 0.98)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6"><rect width="6" height="6" fill="white"/><circle cx="3" cy="3" r="0.5" fill="%23f4eae9"/></svg>') repeat;
  z-index: 5;
  pointer-events: none;
}

.rasgado-top {
  background:
    radial-gradient(ellipse at 50% 20%, rgba(240, 230, 230, 0.95), rgba(253, 242, 243, 0.98)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6"><rect width="6" height="6" fill="white"/><circle cx="3" cy="3" r="0.5" fill="%23f4eae9"/></svg>') repeat;

  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}

.rasgado-bottom {
  overflow: visible;
  background:
    radial-gradient(ellipse at 50% 20%, rgba(255, 255, 255, 0.95), rgba(253, 242, 243, 0.98)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6"><rect width="6" height="6" fill="white"/><circle cx="3" cy="3" r="0.5" fill="%23f4eae9"/></svg>') repeat;

  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}
</style>